"use strict";

import React from 'react';

import {  classMixer  }  from  'generics/utils';
import {  _I_,  defineSimpleTerm  } from 'components/locs';
import {  IconFontAwesome,  IconGlyphicon  } from 'generics/icons';
import {  TrivialDialog  } from 'components/trivialDialog';
import {  ViewItemIconic  } from 'components/commonAssets';
import {  MarketNotifyGameViewItem  } from 'api/gameNotifyAPICall';
import { ClassByHashnameResolver } from 'api/tradeAPICall';
import { spawnDialogWindow } from 'components/dialogHolder';


export function hangleIngamePreview(appId, classInfo)  {
  spawnDialogWindow(ViewIngamePreviewDialog,  {
      appId, classInfo,
    });
}


class ViewIngamePreviewDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.state={
      stage:"ask",
    }
  }


  onBackdropTouch()  {
    const {  stage  } = this.state;
    if ( stage == "pending" )  {
      return;  // must wait till result
    }

    this.props.removeModal();
  }


  sendCommand = ()  =>  {
    const {  stage  } = this.state;
    if ( stage != "ask" )
      return;

    this.setState((prevState, props)  =>  {
      const  {  appId, classInfo  } = props;

      ClassByHashnameResolver.resolve(
          appId, classInfo.market_hash_name

        ).then(
          (assetClass) =>  MarketNotifyGameViewItem( appId, assetClass )

        ).then(
          ()  =>  this.setState({ stage:"done" }),
          ()  =>  this.setState({ stage:"fail" }),

        );

      return { stage:"pending" };
    });
  }


  render()  {
    const {  stage  } = this.state;
    const  {  classInfo,  removeModal  } = this.props;
    switch ( stage )  {
      case "ask"  :
        return  (
          <TrivialDialog
              prefixL10N={`IngamePreview.${stage}`}
              mixClasses={["ingamePreviewDialog"]}
              onCloseButton={removeModal}
              onOkButton={this.sendCommand}
              onCancelButton={removeModal}

              bodyIcon={<ViewItemIconic classInfo={classInfo} />}
              />);

      case "done"  :
        return  (
          <TrivialDialog
              prefixL10N={`IngamePreview.${stage}`}
              mixClasses={["ingamePreviewDialog"]}
              panelType="success"
              onCloseButton={removeModal}
              onOkButton={removeModal}
              />);

      case "fail"  :
        return  (
          <TrivialDialog
              prefixL10N={`IngamePreview.${stage}`}
              mixClasses={["ingamePreviewDialog"]}
              panelType="warning"
              onCloseButton={removeModal}
              onCancelButton={removeModal}
              />);

      case "pending"  :
        return  (
          <TrivialDialog
              prefixL10N={`IngamePreview.${stage}`}
              mixClasses={["ingamePreviewDialog"]}
              panelType="primary"
              bodyIcon={<IconFontAwesome type="cog" size="3x" spin fixedWidth />}
              />);
    }


    return (
        <div className="panel panel-info panel-sm">
          <div className="panel-body">
            <BootButton  variant="danger"  onClick={removeModal}  >
              <IconFontAwesome type="remove" />&nbsp;Broken dialog
            </BootButton>
          </div>
        </div>
      )
  }
};


defineSimpleTerm("IngamePreview.ask.heading",  "View this in game?",  {
  "ru_RU": "Посмотреть в игре?",
  "cs_CZ": "View this in game?",
  "fr_FR": "Voir ceci dans le jeu?",
  "de_DE": "Im Spiel ansehen?",
  "it_IT": "Vuoi vederlo in gioco?",
  "ko_KR": "게임 내에서 확인하시겠습니까?",
  "pl_PL": "Obejrzeć w grze?",
  "pt_PT": "View this in game?",
  "es_ES": "Ver esto en el juego?",
  "zh_CN": "是否在游戏中查看此项目？",
  "zh_TW": "是否在遊戲中查看此項目？"
} );

defineSimpleTerm("IngamePreview.ask.prompt",  "You are about to view this item in game",  {
  "ru_RU": "Этот предмет можно посмотреть в игре",
  "cs_CZ": "You are about to view this item in game",
  "fr_FR": "Vous êtes sur le point de voir cet item dans le jeu",
  "de_DE": "Du siehst dir das Item im Spiel an",
  "it_IT": "Stai per vedere questo oggetto in gioco",
  "ko_KR": "잠시 후 게임 내에서 아이템을 확인하실 수 있습니다",
  "pl_PL": "Zaraz zobaczysz ten przedmiot w grze",
  "pt_PT": "You are about to view this item in game",
  "es_ES": "Estás a punto de ver este elemento en el juego",
  "zh_CN": "您将在游戏中查看此物品",
  "zh_TW": "您將在遊戲中查看此物品"
} );

defineSimpleTerm("IngamePreview.ask.explanation",  "Please make sure you have your game client running...",  {
  "ru_RU": "Убедитесь что ваш игровой клиент запущен",
  "cs_CZ": "Please make sure you have your game client running...",
  "fr_FR": "Assurez-vous que votre jeu est en cours d'exécution ...",
  "de_DE": "Bitte stelle sicher, dass dein Spielclient läuft...",
  "it_IT": "Devi essere sicuro di avere il client di gioco attivo...",
  "ko_KR": "게임 클라이언트가 실행중인지 확인하여 주십시오",
  "pl_PL": "Upewnij się, ze klient gry działa...",
  "pt_PT": "Please make sure you have your game client running...",
  "es_ES": "Asegúrate de que tu cliente de juego se esté ejecutando...",
  "zh_CN": "请确保你的游戏客户端正在运行…",
  "zh_TW": "請確保你的遊戲客戶端正在運行…"
} );

defineSimpleTerm("IngamePreview.ask.okButton",  "Sure, show me",  {
  "ru_RU": "Окей",
  "cs_CZ": "Sure, show me",
  "fr_FR": "Oui, montrez-moi",
  "de_DE": "Sicher, zeig her",
  "it_IT": "Certo, mostrami",
  "ko_KR": "네, 보여주세요",
  "pl_PL": "Tak, pokaż mi",
  "pt_PT": "Sure, show me",
  "es_ES": "Claro, muéstrame",
  "zh_CN": "是的，请显示",
  "zh_TW": "是的，請顯示"
} );

// defineSimpleTerm("IngamePreview.ask.defaultButton",  "...",  {
//   "ru_RU": "",
// } );

defineSimpleTerm("IngamePreview.ask.cancelButton",  "No",  {
  "ru_RU": "Нет",
  "cs_CZ": "Ne",
  "fr_FR": "Non",
  "de_DE": "Nein",
  "it_IT": "No",
  "ko_KR": "아니오",
  "pl_PL": "Nie",
  "pt_PT": "No",
  "es_ES": "No",
  "zh_CN": "不用",
  "zh_TW": "不用"
} );



defineSimpleTerm("IngamePreview.done.heading",  "Done",  {
  "ru_RU": "Готово",
  "cs_CZ": "Hotovo",
  "fr_FR": "Terminé",
  "de_DE": "Fertig",
  "it_IT": "Fatto",
  "ko_KR": "확인",
  "pl_PL": "Zakończono",
  "pt_PT": "Done",
  "es_ES": "Listo",
  "zh_CN": "完成",
  "zh_TW": "完成"
} );

defineSimpleTerm("IngamePreview.done.prompt",  "",  {
  "ru_RU": "",
  "cs_CZ": "",
  "fr_FR": "",
  "de_DE": "",
  "it_IT": "",
  "ko_KR": "",
  "pl_PL": "",
  "pt_PT": "",
  "es_ES": "",
  "zh_CN": "",
  "zh_TW": ""
} );

defineSimpleTerm("IngamePreview.done.explanation",  "Successfully sent",  {
  "ru_RU": "Отправлено успешно",
  "cs_CZ": "Úspěšně posláno",
  "fr_FR": "Envoyé avec succès",
  "de_DE": "Erfolgreich gesendet",
  "it_IT": "Inviato con successo",
  "ko_KR": "전송에 성공하였습니다",
  "pl_PL": "Pomyślnie wysłano",
  "pt_PT": "Successfully sent",
  "es_ES": "Enviado exitosamente",
  "zh_CN": "已成功发送",
  "zh_TW": "已成功發送"
} );

defineSimpleTerm("IngamePreview.done.okButton",  "Ok",  {
  "ru_RU": "Ок",
  "cs_CZ": "Ok",
  "fr_FR": "Ok",
  "de_DE": "Ok",
  "it_IT": "Ok",
  "ko_KR": "확인",
  "pl_PL": "Ok",
  "pt_PT": "Ok",
  "es_ES": "Ok",
  "zh_CN": "确定",
  "zh_TW": "確定"
} );

// defineSimpleTerm("IngamePreview.done.defaultButton",  "...",  {
//   "ru_RU": "...",
// } );

// defineSimpleTerm("IngamePreview.done.cancelButton",  "...",  {
//   "ru_RU": "...",
// } );




defineSimpleTerm("IngamePreview.fail.heading",  "Failed",  {
  "ru_RU": "Что-то пошло не так",
  "cs_CZ": "Selhání",
  "fr_FR": "Echec",
  "de_DE": "Gescheitert",
  "it_IT": "Fallito",
  "ko_KR": "실패",
  "pl_PL": "Niepowodzenie",
  "pt_PT": "Failed",
  "es_ES": "Fallado",
  "zh_CN": "已失败",
  "zh_TW": "已失敗"
} );

defineSimpleTerm("IngamePreview.fail.prompt",  "",  {
  "ru_RU": "",
  "cs_CZ": "",
  "fr_FR": "",
  "de_DE": "",
  "it_IT": "",
  "ko_KR": "",
  "pl_PL": "",
  "pt_PT": "",
  "es_ES": "",
  "zh_CN": "",
  "zh_TW": ""
} );

defineSimpleTerm("IngamePreview.fail.explanation",  "Could not contact the game client",  {
  "ru_RU": "Не удалось связаться с игровым клиентом",
  "cs_CZ": "Nepovedl se kontaktovat herní klient",
  "fr_FR": "Impossible de contacter le client du jeu",
  "de_DE": "Der Spielclient konnte nicht erreicht werden",
  "it_IT": "Non deve contattare il client di gioco",
  "ko_KR": "게임 클라이언트와 연동할 수 없습니다",
  "pl_PL": "Nie można połączyć z klientem gry",
  "pt_PT": "Could not contact the game client",
  "es_ES": "No se pudo contactar con el cliente del juego",
  "zh_CN": "无法联系游戏客户端",
  "zh_TW": "無法聯繫遊戲客戶端"
} );

// defineSimpleTerm("IngamePreview.fail.okButton",  "",  {
//   "ru_RU": "",
// } );

// defineSimpleTerm("IngamePreview.fail.defaultButton",  "",  {
//   "ru_RU": "",
// } );

defineSimpleTerm("IngamePreview.fail.cancelButton",  "Ok",  {
  "ru_RU": "Ок",
  "cs_CZ": "Ok",
  "fr_FR": "Ok",
  "de_DE": "Ok",
  "it_IT": "Ok",
  "ko_KR": "확인",
  "pl_PL": "Ok",
  "pt_PT": "Ok",
  "es_ES": "Ok",
  "zh_CN": "确定",
  "zh_TW": "確定"
} );



defineSimpleTerm("IngamePreview.pending.heading",  "Just a second...",  {
  "ru_RU": "Секундочку...",
  "cs_CZ": "Chvilku strpení...",
  "fr_FR": "Un instant...",
  "de_DE": "Nur eine Sekunde...",
  "it_IT": "Giusto un secondo...",
  "ko_KR": "잠시만 기다려 주세요...",
  "pl_PL": "Jeszcze chwila...",
  "pt_PT": "Just a second...",
  "es_ES": "Sólo un segundo...",
  "zh_CN": "请稍候…",
  "zh_TW": "請稍候…"
} );

defineSimpleTerm("IngamePreview.pending.prompt",  "Notifying your game client",  {
  "ru_RU": "Отправка уведомления игровому клиенту",
  "cs_CZ": "Komunikace se hrou",
  "fr_FR": "Notification de votre client de jeu",
  "de_DE": "Deinen Spielclient anzeigen",
  "it_IT": "Notifica in gioco",
  "ko_KR": "게임 클라이언트 확인중",
  "pl_PL": "Powiadamianie twojego klienta gry",
  "pt_PT": "Notifying your game client",
  "es_ES": "Notificando a tu cliente de juego",
  "zh_CN": "正在通知你的游戏客户端",
  "zh_TW": "正在通知你的遊戲客戶端"
} );

defineSimpleTerm("IngamePreview.pending.explanation",  "",  {
  "ru_RU": "",
  "cs_CZ": "",
  "fr_FR": "",
  "de_DE": "",
  "it_IT": "",
  "ko_KR": "",
  "pl_PL": "",
  "pt_PT": "",
  "es_ES": "",
  "zh_CN": "",
  "zh_TW": ""
} );

// defineSimpleTerm("IngamePreview.pending.okButton",  "",  {
//   "ru_RU": "",
// } );

// defineSimpleTerm("IngamePreview.pending.defaultButton",  "",  {
//   "ru_RU": "",
// } );

// defineSimpleTerm("IngamePreview.pending.cancelButton",  "",  {
//   "ru_RU": "",
// } );

